import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BriefcaseBusiness, CalendarClock, ShieldCheck } from "lucide-react";
import { http, requestErrorMessage } from "@/lib/erp";
import RecruitmentApplicationForm from "@/components/recruitment/RecruitmentApplicationForm";
import "./recruitment.css";

export default function PublicRecruitment() {
  const { token } = useParams();
  const [candidate, setCandidate] = useState(null);
  const [state, setState] = useState("loading");
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    http.get(`/public/recruitment/${encodeURIComponent(token)}`).then(({ data }) => {
      if (!active) return;
      if (data.submitted) setState("submitted");
      else if (data.expires_at && new Date(data.expires_at).getTime() < Date.now()) setState("expired");
      else { setCandidate({ ...data, token }); setState("ready"); }
    }).catch((e) => {
      if (!active) return;
      if (e?.response?.status === 410) setState("expired");
      else if (e?.response?.status === 409) setState("submitted");
      else if (e?.response?.status === 404) setState("invalid");
      else { setError(requestErrorMessage(e, "load this invitation")); setState("error"); }
    });
    return () => { active = false; };
  }, [token]);
  const retry = () => { setState("loading"); setError(""); http.get(`/public/recruitment/${encodeURIComponent(token)}`).then(({data}) => {
    if (data.submitted) setState("submitted"); else if (data.expires_at && new Date(data.expires_at).getTime() < Date.now()) setState("expired");
    else { setCandidate({ ...data, token }); setState("ready"); }
  }).catch((e) => { setError(requestErrorMessage(e, "load this invitation")); setState(e?.response?.status === 404 ? "invalid" : e?.response?.status === 410 ? "expired" : "error"); }); };
  const endStates = {
    submitted: ["Application already submitted", "This invitation has already been used. Thank you for your interest in VGRUPS RECRUIT."],
    expired: ["Invitation expired", "This application link is no longer active. Please contact the person who invited you."],
    invalid: ["Invitation not found", "This application link is invalid or has been withdrawn. Please check with your hiring contact."],
    error: ["We couldn’t open this link", error || "Please check your connection and try again."],
  };
  return <div className="recruitment recruit-public">
    <div className="recruit-public-shell">
      <div className="recruit-public-brand"><div className="recruit-brand-mark">V</div><div><div className="recruit-brand-name">VGRUPS RECRUIT</div><div className="recruit-brand-caption">Healthcare distribution</div></div></div>
      {state === "loading" ? <div className="recruit-card recruit-public-state" aria-label="Loading invitation"><div className="recruit-skeleton" /><div className="recruit-skeleton" /><div className="recruit-skeleton" /></div>
        : endStates[state] ? <div className="recruit-card recruit-public-state" role="status"><ShieldCheck size={26} color="#087d79" style={{ margin: "0 auto" }} /><h1>{endStates[state][0]}</h1><p>{endStates[state][1]}</p>{state === "error" && <button className="recruit-button recruit-button-primary" onClick={retry} type="button">Try again</button>}</div>
          : candidate && <>
            <header className="recruit-public-banner">
              <div className="recruit-eyebrow" style={{ color:"#b5d9d5" }}>Candidate application</div>
              <h1>Let’s get to know you.</h1>
              <p>Complete your application for a role with {candidate.company_name || "VGRUPS RECRUIT"}.</p>
              <div className="recruit-public-meta"><span><BriefcaseBusiness size={12} style={{ verticalAlign:"middle", marginRight:5 }} />{candidate.role}</span><span>Application {candidate.application_number}</span>{candidate.expires_at && <span><CalendarClock size={12} style={{ verticalAlign:"middle", marginRight:5 }} />Apply by {new Date(candidate.expires_at).toLocaleDateString("en-IN", { day:"numeric", month:"short", year:"numeric" })}</span>}</div>
            </header>
            <RecruitmentApplicationForm key={candidate.token} candidate={candidate} />
          </>}
      <p className="recruit-privacy-note"><ShieldCheck size={12} style={{ verticalAlign:"middle", marginRight:4 }} />Your application is submitted securely to the VGRUPS hiring team. Do not share this personal link.</p>
    </div>
  </div>;
}